<template>
  <ul class="mic-list">
    <template v-if="microphones.length > 0">
      <li v-for="microphone in microphones" :key="microphone.id" class="mic-item">
        <button
          type="button"
          :disabled="!microphone.isConnected || microphone.isSelected"
          class="no-padding"
          @click="
            emit('select', {
              id: microphone.id,
              label: microphone.label,
              customLabel: microphone.customLabel,
            })
          "
        >
          <span :class="['status-dot', microphone.isConnected ? 'connected' : 'disconnected']" />
          <Tag
            v-if="microphone.customLabel?.trim()"
            :label="microphone.customLabel"
            type="gray-light"
            class="mic-tag"
          />
          <span class="small">{{ microphone.label }}</span>
        </button>
      </li>
    </template>
    <li v-else>
      <button type="button">
        <span class="small">연결된 마이크가 없습니다.</span>
      </button>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { inject, Ref, ref } from 'vue';

import { IMicrophone } from '@/types/components';
import { ij_ableMicList } from '@/utils/injectionKeys';

import Tag from '../base/Tag.vue';

const emit = defineEmits<{
  select: [mic: Pick<IMicrophone, 'id' | 'label' | 'customLabel'>];
}>();

const microphones = inject<Ref<(IMicrophone & { isSelected: boolean })[]>>(
  ij_ableMicList,
  ref<(IMicrophone & { isSelected: boolean })[]>([])
);
</script>

<style scoped lang="scss">
.mic-list {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 39rem;
  overflow-y: auto;
}

.mic-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem;
  border-radius: 0.5rem;
  cursor: pointer;

  &:hover {
    background: var(--surface-hover-gray-dimmer);
  }

  &:last-child {
    border-bottom: none;
  }
}

.status-dot {
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 50%;
  flex-shrink: 0;
  display: inline-block;

  &.connected {
    background-color: var(--success);
  }
  &.disconnected {
    background-color: var(--surface-gray);
  }
}

.no-padding {
  padding: 0;
}
</style>
